import { z } from 'zod';

export const RetireExamCenterRoomFormSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(1, { message: 'กรุณาระบุสาเหตุที่ยกเลิก' })
    .max(255, { message: 'ความยาวต้องไม่เกิน 255 ตัวอักษร' }),
});

export type RetireExamCenterRoomFormInput = z.infer<typeof RetireExamCenterRoomFormSchema>;
